module.exports = __webpack_public_path__ + "static/img/a046.0f4441b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a046.jpg
// module id = JvZH
// module chunks = 0